






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ActionsDropdownItem extends Vue {
    @Prop({ type: Boolean, default: false }) readonly green!: boolean
    @Prop({ type: Boolean, default: false }) readonly red!: boolean

    get componentClass(): object {
        return {
            'actions-dropdown-item': true,
            'actions-dropdown-item--green': this.green,
            'actions-dropdown-item--red': this.red,
        }
    }
}
